module.exports = __webpack_public_path__ + "img/mova-club.42ab96f9.jpg";